const ifNotAuthenticated = (to, from, next) => {
  if(sessionStorage.getItem('isLogin') == null) {
    next();
  } else {
    next({
      name: 'home',
      query: {
        redirect: to.name
      }
    })
  }
}

const ifAuthenticated = (to, from, next) => {
  if(sessionStorage.getItem('isLogin') != null) {
      next(); // Cho phép vào
  } else {
    next({
      name: 'login'
    })
  }
}

export {
    ifNotAuthenticated, ifAuthenticated
}
